<div
  [@WindowOpenClose]="windowVisible.getValue() ? 'visible' : 'invisible'"
  (click)="windowClick()"
>
  <dialog-header
    [label]="title"
    [dialogRef]="dialogRef"
    (mousedown)="windowClick()"
    [object]="this"
  >
  </dialog-header>
  <form [formGroup]="form">
    <div class="add-preset-body">
      <div class="preset-info">
        <mat-form-field>
          <input
            matInput
            autocomplete="off"
            placeholder="Preset Name"
            formControlName="presetName"
        /></mat-form-field>
        <div class="preset-type">
          <img [src]="presetLayout.symbol" alt="Preset Type Symbol" />
        </div>
      </div>
      <div class="preset-row">
        <span>Slot</span>
        <span>Camera Name</span>
        <span>Stream Name</span>
      </div>
      <div class="preset-sensors" *ngIf="preset">
        <div *ngFor="let cam of preset.cameras">
          <div class="preset-row">
            <div class="p-id">{{ cam.slot + 1 }}</div>
            <div class="p-name">{{ cam.cameraName }}</div>
            <div class="p-name">{{ cam.cameraStreamName }}</div>
          </div>
        </div>
      </div>

      <div class="submit" *ngIf="state != 'showPreset'">
        <button
          mat-stroked-button
          (click)="onSubmit()"
          [disabled]="!form.valid"
        >
          {{ state == 'addPreset' ? "ACTIONS.ADD" : "Update" | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
